import { ResolvedComponentsConfiguration } from "@zoovu/runner-browser-api";
import mediaQuery from "../abstract/media-query";
import globals from "../partials/global-variables";

export default {
  container: {
    ".multi-answer &": {
      "& .answer-image": {
        display: "block",
      },
      "& .answer-info-text": {
        display: "block",
        order: "3",
        textAlign: "left",
        paddingLeft: 0,
        paddingBottom: "10px",
        paddingTop: "0px",
      },
      "& .question-type-hint": {
        display: "none",
      },
      "& > div": {
        [`@media (${globals.breakpoints.$xs})`]: {
          width: `${globals.fixedpoints.$mobilelead} !important`,
        },
        [`@media (${globals.breakpoints.$minXs})`]: {
          width: `${globals.fixedpoints.$tabletlead} !important`,
        },
        [`@media (${globals.breakpoints.$minSm})`]: {
          width: `${globals.fixedpoints.$desktoplead} !important`,
        },
      },
    },
    "& .answers-wrapper": {
      alignItems: "stretch",
      display: "flex",
      flexFlow: "wrap row",
      justifyContent: "center",
      "& .answer": {
        position: "relative",
        margin: [0, 0, "25px"],
        [`@media (${globals.breakpoints.$xs})`]: {
          width: "calc(50% - 15px) !important",
          margin: [0, 0, "15px"],
        },
        [mediaQuery.hover]: {
          "&:hover": {
            outline: "none",
          },
        },
        "&:focus": {
          outline: "none",
          outlineColor: "red !important",
        },
        "& label:focus": {
          outlineColor: "black !important",
        },
      },
      "& .answer-image": {
        position: "relative",
        width: "100%",
        maxWidth: "250px",
        margin: "0 auto",
        "&::after": {
          content: "' '",
          display: "block",
          paddingBottom: "100%",
        },
        [`@media (${globals.breakpoints.$maxSm})`]: {
          width: "100%",
          maxWidth: "200px",
        },
        [`@media (${globals.breakpoints.$xs})`]: {
          width: "100%",
          maxWidth: "145px",
        },
      },
      "& .fullRow": {
        "& .answer-image": {
          maxWidth: "180px",
          [`@media (${globals.breakpoints.$xs})`]: {
            maxHeight: "100px",
          },
        },
      },
      "&.checkbox": {
        "& .answer-icon-wrapper": {
          "& .answer-icon": {
            borderRadius: "6px",
            "&:after": {
              backgroundColor: "transparent",
              backgroundImage: (configuration: ResolvedComponentsConfiguration): string =>
                `${globals.customerSpriteTheme5(configuration)}`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "-40px -63px",
              width: "35px",
              height: "35px",
              top: 0,
              left: 0,
              [`@media (${globals.breakpoints.$xs})`]: {
                width: "20px",
                height: "20px",
                backgroundPosition: "-47px -71px",
              },
            },
          },
        },
      },
    },
  },
};
